import { useEffect, useState } from "react";
import { cardTypeIcon, PAYMENT_GATEWAY, PAYMENT_METHOD_STRING } from "../../../../constants";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";

export const OrderStatus = ({ data, ispending = false }) => {
  const [details, setDetails] = useState(null);
  useEffect(() => {
    if (data) {
      setDetails(data);
    }
  }, [data]);
  return (
    <div className="col-md-6 mt-3 mt-md-0">
      {/* Order Details */}

      <div className="order-address">
        <div className="card order-address-card">
          <div className="card-header">
            <h5>
              <span className="wes wes-download" />
              Order Details
            </h5>
          </div>

          <div className="card-body order-address-body ">
            <div className="row">
              {details && (
                <div className="col-lg-12" style={{ textTransform: "capitalize" }}>
                  <div className="orderStatus mb-3 d-line-flex">
                    <h6>Order Id: </h6>
                    <p className="myorderStatus">{details.orderId}</p>
                  </div>
                  <div className="orderStatus mb-3 d-line-flex">
                    <h6>Order Status: </h6>
                    <p className="myorderStatus myorderStatus-completed">{details.orderStatus}</p>
                  </div>
                  {!ispending && (
                    <div className="orderStatus mb-3 d-line-flex">
                      <h6>Payment: </h6>
                      {PAYMENT_GATEWAY.includes(details.paymentMethod) ? (
                        <p className="myorderCard">
                          <img src={cardTypeIcon[details.cardType] || cardTypeIcon["masterNot"]} alt="Card-details" />
                          {` ${details.cardNumber}  Credit Card`}
                        </p>
                      ) : (
                        <div className="placed-order-info">
                          {`${PAYMENT_METHOD_STRING[details.paymentMethod] || details.paymentMethod}`}
                        </div>
                      )}
                    </div>
                  )}
                  <div className="orderStatus mb-3 d-line-flex">
                    <h6>Users: </h6>
                    <p className="myorderCard">{String(details.createdUser).toLowerCase()}</p>
                  </div>
                  <div className="orderStatus d-line-flex">
                    <h6>Shipping: </h6>
                    <p className="myorderCard mb-0">{details.shipMethod}</p>
                    {details.trackOrderUrl && details.trackOrderNumber && (
                      <a href={details.trackOrderUrl} target="_blank" className="orderShipping">
                        {`Australia_Post_eParcel-${details.trackOrderNumber}`}
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Order Details */}
    </div>
  );
};
